import { CONFIG, UNIT, TICKET_CRM, USER, ROLES } from '../../utils/constants';
import profileMixin from '@/mixins/modules/profile';
import { hasPermission } from '@/utils';
import enums from '@/utils/enums';
import logTrace from '@/services/logTrace';
export default {
  mixins: [profileMixin],
  data() {
    return {
      supportLoading: false,
      supportError: false,
      listTicketsPromise: null,
      listTicketsPromiseBody: null,
    };
  },
  computed: {
    excludedModules() {
      return this.$store.getters[CONFIG.GET_NAVIGATION_RULES].excludeModules;
    },
    ticketCrmEnabled() {
      return this.$store.getters[TICKET_CRM.GET_ENABLED];
    },
    ticketCrmToken() {
      return this.$store.getters[TICKET_CRM.GET_TOKEN];
    },
    supportItems() {
      return this.$store.getters[TICKET_CRM.GET_TICKETS];
    },
    hasNewTicket() {
      return this.$store.getters[TICKET_CRM.HAS_NEW_TICKET];
    },
  },
  methods: {
    async getTicketCrmToken(unitObj) {
      if (!this.ticketCrmEnabled || !hasPermission(enums.supportViewProfiles)) {
        console.error('TicketCRM - Does not have permission');
        return;
      }
      return await this.$store.dispatch(TICKET_CRM.FETCH_TOKEN, unitObj);
    },
    async getTicket(number) {
      try {
        if (!hasPermission(enums.supportViewProfiles)) return;
        let ticketCrmToken = this.ticketCrmToken;
        if (!ticketCrmToken) ticketCrmToken = await this.getTicketCrmToken();

        const url = `${process.env.TICKET_CRM_API_URL}/getTicket`;
        return await this.requestService(url, 'GET', {
          params: {
            ticketCrmToken,
            number,
          },
          localErrorHandling: true,
        });
      } catch (err) {
        throw err;
      }
    },
    async sendTicket(payload, localErrorHandling = false) {
      try {
        if (!hasPermission(enums.supportViewProfiles)) return;
        let ticketCrmToken = this.ticketCrmToken;
        if (!ticketCrmToken) {
          ticketCrmToken = await this.getTicketCrmToken();
          if (!ticketCrmToken) return;
        }

        const url = `${process.env.TICKET_CRM_API_URL}/newTicket`;

        const body = {
          ticketCrmToken,
          productSku: this.selectedUnit.sku,
          payload,
          unitId: this.selectedUnit.unit.id,
        };

        if (this.user.userRole === ROLES.CLIENT_ROLE) {
          let imobmeData = this.$store.getters[USER.GET_IMOBME_DATA];
          if (!imobmeData) {
            await this.getUser();
            imobmeData = this.$store.getters[USER.GET_IMOBME_DATA];
          }
          body.customerId = imobmeData.id;
        } else if (this.user.userRole === ROLES.SYNDIC_ROLE) {
          body.email = this.user.email;
        } else {
          throw new Error(`Invalid userRole: ${this.user.userRole}`);
        }

        return await this.requestService(url, 'POST', {
          data: body,
          localErrorHandling,
          retries: 0,
        });
      } catch (err) {
        throw err;
      }
    },
    async ticketInteract(number, payload) {
      try {
        if (!hasPermission(enums.supportViewProfiles)) return;
        let ticketCrmToken = this.ticketCrmToken;
        if (!ticketCrmToken) {
          ticketCrmToken = await this.getTicketCrmToken();
          if (!ticketCrmToken) return;
        }

        const url = `${process.env.TICKET_CRM_API_URL}/ticketInteract`;
        return await this.requestService(url, 'POST', {
          data: {
            ticketCrmToken,
            number,
            productSku: this.selectedUnit.sku,
            payload,
          },
          localErrorHandling: true,
          retries: 0,
        });
      } catch (err) {
        throw err;
      }
    },

    async getOctadeskAllProposersTickets() {
      try {
        if (!hasPermission(enums.supportViewProfiles)) return;

        let ticketCrmToken = this.ticketCrmToken;
        if (!ticketCrmToken) {
          ticketCrmToken = await this.getTicketCrmToken();
          if (!ticketCrmToken) return;
        }

        if (!this.supportItems.lastTicket || this.hasNewTicket) {
          this.supportLoading = true;
        }

        const url = `${process.env.TICKET_CRM_API_URL}/listTickets`;
        const body = {
          ticketCrmToken,
          productSku: this.selectedUnit.sku,
          unitId: this.selectedUnit.unit.id,
        };

        if (
          this.listTicketsPromise &&
          this.listTicketsPromiseBody.productSku == body.productSku
        ) {
          return;
        }

        for (let retries = 2; retries >= 0; retries--) {
          try {
            this.listTicketsPromise = this.requestService(url, 'POST', {
              data: body,
              retries: 1,
            });
            this.listTicketsPromiseBody = body;
            const [result] = await Promise.all([this.listTicketsPromise]);
            if (!result) {
              this.supportError = true;
            } else {
              retries = 0;
              this.supportError = false;
              this.$store.commit(TICKET_CRM.NEW_TICKET_LISTED);
              this.$store.commit(
                TICKET_CRM.SET_TICKETS,
                result || {
                  ...TICKET_CRM.DEFAULT_SUPPORT_ITEMS,
                }
              );
              this.listTicketsPromise = null;
              this.listTicketsPromiseBody = null;
              break;
            }
          } catch (error) {
            console.error('Retrying octadesk list tickets', error);
            if (retries < 1) {
              this.supportError = true;
            }
            this.listTicketsPromise = null;
            this.listTicketsPromiseBody = null;
          }
        }
        this.supportLoading = false;
      } catch (err) {
        this.supportError = true;
        this.supportLoading = false;
        throw err;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/modules/support.js